// interface
export interface RewardData {
    reward_day_data: any[]
    rewardDay: number,
    rewardTime: number,
    record_status: number,
    rewardCoin: number
    activeStatus: number,
    rechargeCoin: number,
}

export interface DayItem {
    reward_day: number
    reward_data: RewardData
}
export interface ExtraConfig {
    reward_day_list: []
}
export interface ConfigData {
    resultDTO: object
    user_join_date: number
}
export interface MysteryConfig {
    activityIntro: string
    extraConfig: ExtraConfig
    config: ConfigData
    startTime: number,
    floatIcon: string,
}

export interface BonusData {
    isPopping : boolean
    activityInfo : any[]
    rewardDayList : any[]
    rewardDayData : Record<number, RewardData>
    mysteryDataConfig : MysteryConfig
    dayList : DayItem[]
    selectedTab : DayItem
    bannerIcon : string
}
// constant
export const MYSTERIO_IMG = [
    { img: require("@/assets/bonus/misterioso_1.png") },
    { img: require("@/assets/bonus/misterioso_2.png") },
    { img: require("@/assets/bonus/misterioso_3.png") },
    { img: require("@/assets/bonus/misterioso_4.png") },
    { img: require("@/assets/bonus/misterioso_5.png") }
]
export const MYSTERIO_IMG_THEME_TWO = [
    { img: require("@/assets/themetwo/Box1_close.png") },
    { img: require("@/assets/themetwo/Box2_close.png") },
    { img: require("@/assets/themetwo/Box3_close.png") },
    { img: require("@/assets/themetwo/Box4_close.png") },
    { img: require("@/assets/themetwo/Box5_close.png") }
]

// functions
export const calculateValue = (value: string) => {
    return Number(value);
}